var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.366 39.197V23.6366L176.987 0H185.559L188.232 13.6324H188.775L191.61 0H200L192.644 22.9972V39.197H184.366Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.38 25.6511H166.549L163.923 6.47095H163.212L160.38 25.6511ZM168.438 39.197L167.346 31.8445H159.543L158.423 39.197H150.271L157.365 0H169.839L176.93 39.197H168.438Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.035 33.2977H134.043C137.494 33.2977 138.219 31.2739 138.219 29.5758V9.62195C138.219 7.92348 137.494 5.89935 134.043 5.89935H132.035V33.2977ZM123.756 39.197V0H137.044C143.581 0 146.497 3.11897 146.497 10.1128V29.5274C146.497 36.665 141.405 39.197 137.044 39.197H123.756Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.139 39.197L105.797 24.2467L103.156 28.4826V39.197H95.1716V0H103.156V16.4288H103.572L110.122 0H118.842L111.344 16.2149L118.956 39.197H110.139Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3426 39.197V0H88.6919V6.78299H77.6209V15.7424H87.3144V22.5233H77.6209V32.4154H89.1347V39.197H69.3426Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5135 39.197V0H62.8625V6.78299H51.7922V15.7424H61.485V22.5233H51.7922V32.4154H63.3057V39.197H43.5135Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5612 39.197L19.6404 14.2885H19.323L16.0124 39.197H6.73096L0 0H8.49493L12.042 28.6376H12.3591L15.5634 0H23.5497L26.5617 28.6376H26.9218L30.4255 0H38.7219L31.8427 39.197H22.5612Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekday);
export default __webpack_public_path__ + "static/media/Weekday.d979a7c6c502f6ad0ce630f63f95048a.svg";
export { ForwardRef as ReactComponent };